import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { ToastContentProps } from 'react-toastify';

/**
 * "Sonuç nereye gitti?" yönlendirmesi: bir işlemden sonra kullanıcıya
 * sonucu nerede takip edeceğini söyler ve tek tıkla o sayfaya götürür.
 */

export type NextStepAction = {
    to: string;
    label: string;
};

type NextStepLinkProps = NextStepAction & {
    onNavigate?: () => void;
};

const linkStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: '4px 12px',
    border: 'none',
    borderRadius: 999,
    background: 'var(--beetinq-primary, #2563eb)',
    color: '#fff',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
};

export const NextStepLink = ({ to, label, onNavigate }: NextStepLinkProps) => {
    const navigate = useNavigate();

    const handleClick = (event: React.MouseEvent) => {
        event.stopPropagation();
        onNavigate?.();
        navigate(to);
    };

    return (
        <button type="button" className="beetinq-next-step-link" style={linkStyle} onClick={handleClick}>
            {label}
            <i className="fa-solid fa-arrow-right" aria-hidden="true" />
        </button>
    );
};

type NextStepContentProps = Partial<ToastContentProps> & {
    message: string;
    action: NextStepAction;
};

export const NextStepContent = ({ message, action, closeToast }: NextStepContentProps) => (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 8 }}>
        <span style={{ fontSize: 14, lineHeight: 1.45, color: 'var(--beetinq-text, #172554)' }}>{message}</span>
        <NextStepLink {...action} onNavigate={closeToast} />
    </div>
);
